import React from 'react';

import Modal from 'antd/es/modal/Modal';

import { months } from '@app/components/LocalCommon/Constants/Months';
import CustomAvatar from '@app/components/UI/CustomAvatar/CustomAvatar';
import { TesAuthorCredits, VetAvatar } from '@app/components/UI/VetTesCard/VetTesCard';
import '@app/scss/components/vetTesModal.scss';
import '@app/scss/localCommon/components/attachment.scss';

const imagePlaceholder = require('@images/image-placeholder.png');

const VetTesPreviewModal = ({ modalVisible, setModalVisible, tes }) => {
	const petImgHeight = 400;
	const petImgWidth = 280;
	const date = new Date();
	const today = {
		month: months[date.getMonth()],
		year: date.getFullYear(),
		day: date.getDate(),
	};

	const imageAltCapture = `
		Lap of Love Veterinary Hospice ${tes.city ? tes.city : ''},
		${tes.state ? tes.state : ''} Testimonial for ${tes.vetName}
		${tes.firstName ? `by ${tes.firstName} ${tes.lastName}` : ''}
	`;

	const {
		firstName,
		lastName,
		vetName = '',
		message = '',
		city = '',
		state = '',
		vetAvatar = imagePlaceholder,
		imgSrc = '',
		isShowName,
	} = tes;

	return (
		<Modal
			wrapClassName="modal-wrap vet-tes-preview-modal"
			open={modalVisible}
			onOk={() => setModalVisible(false)}
			onCancel={() => setModalVisible(false)}
			width={1037}
			centered
		>
			<div className="vet-tes-card__wrapper">
				<div className="vet-tes-card">
					{vetName && (
						<VetAvatar vetAvatar={vetAvatar} vetName={`${vetName}`} />
					)}

					{message && (
						<div className="vet-tes-card_swipe">
							<p className="vet-tes-card__text">{message}</p>
						</div>
					)}

					<TesAuthorCredits firstName={firstName} lastName={lastName} city={city} state={state} date={today} isShowName={isShowName} />
				</div>
				{imgSrc && (
					<div className="vet-tes-card__pet-img">
						<CustomAvatar
							src={imgSrc}
							maxWidth={petImgWidth}
							maxHeight={petImgHeight}
							alt={imageAltCapture}
							errorAvatar={imagePlaceholder}
						/>
					</div>
				)}
			</div>
		</Modal>
	);
};

export default VetTesPreviewModal;
